if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          if (!this.productElement || !this.modalContent) {
            window.location.href = opener.getAttribute('data-product-url');
            return;
          }
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) window.ProductModel.loadShopifyXR();
          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();
          this.layoutQuickBuy();
          this.injectBuyNowButton();
          try {
            if (typeof DTWishlist === 'function') DTWishlist();
          } catch (error) {
            console.error('Quick add wishlist init failed', error);
          }
          super.show(opener);
          this.enableInfoScroll();
        })
        .catch((error) => {
          console.error('Quick add failed', error);
          window.location.href = opener.getAttribute('data-product-url');
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });      
    }

    preventVariantURLSwitching() {
    const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
     if (!variantPicker) return;      
     variantPicker.setAttribute('data-update-url', 'false');      
      $('input:radio[name="Color"]').click(function() {      
      $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
      $(this).next('.swatch-element').addClass('clicked');
          });
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();      
       
      const productEnquiry = this.productElement.querySelectorAll('enquiryPopUp');      
      if (productEnquiry) productEnquiry.forEach((enquiryModal) => enquiryModal.remove());
      
      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        this.productElement.querySelectorAll('thumbnail-list').forEach((list) => list.remove());

      
      
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
      variantSelect.dataset.originalSection = sectionId;
      });      
          
    }

    layoutQuickBuy() {
      const info = this.modalContent.querySelector('.product__info-container');
      if (!info) return;

      this.injectDescription(info);

      const details = info.querySelector('.product__view-details');
      if (details) info.appendChild(details);
    }

    enableInfoScroll() {
      const dialog = this.querySelector('.quick-add-modal__content');
      const info = this.modalContent && this.modalContent.querySelector(
        '.product__info-wrapper .product__info-container, .product__info-container'
      );
      if (!dialog || !info) return;

      const apply = () => {
        const height = dialog.clientHeight;
        if (!height) return;
        info.style.maxHeight = height + 'px';
        info.style.height = height + 'px';
        info.style.overflowY = 'auto';
        info.style.overflowX = 'hidden';
      };

      apply();
      requestAnimationFrame(apply);
    }

    injectDescription(info) {
      if (info.querySelector('.quick-add-description')) return;

      let text = '';
      const jsonLd = this.modalContent.querySelector('script[type="application/ld+json"]');
      if (jsonLd) {
        try {
          const data = JSON.parse(jsonLd.textContent);
          if (data && data.description) text = String(data.description);
        } catch (error) {
          console.error('Quick add description parse failed', error);
        }
      }

      if (!text) {
        const rte = this.modalContent.querySelector(
          '.product__accordion .accordion__content.rte, [data-id="tab-description"], .dt-sc-tabs-content.rte'
        );
        if (rte) text = rte.textContent;
      }

      text = (text || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      const desc = document.createElement('div');
      desc.className = 'quick-add-description';
      desc.textContent = text;

      const price = info.querySelector('.price-wrapper') || info.querySelector('.price');
      const form = info.querySelector('product-form, .product-form');

      if (price) {
        price.insertAdjacentElement('afterend', desc);
      } else if (form) {
        form.insertAdjacentElement('beforebegin', desc);
      } else {
        info.appendChild(desc);
      }
    }

    injectBuyNowButton() {
      const productForm = this.modalContent.querySelector('product-form form[data-type="add-to-cart-form"]');
      if (!productForm) return;
      if (this.modalContent.querySelector('.quick-add-buy-now-btn')) return;

      const buyNowBtn = document.createElement('button');
      buyNowBtn.type = 'button';
      buyNowBtn.className = 'quick-add-buy-now-btn';
      buyNowBtn.innerHTML = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Buy Now`;

      buyNowBtn.addEventListener('click', () => {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return;

        const qtyInput = this.modalContent.querySelector('input[name="quantity"], .quantity__input');
        const qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
        window.location.href = '/cart/' + variantInput.value + ':' + qty + '?checkout';
      });

      const buttonsContainer = productForm.querySelector('.product-form__buttons');
      if (buttonsContainer) {
        const wrapper = document.createElement('div');
        wrapper.className = 'quick-add-buy-now-wrapper';
        wrapper.appendChild(buyNowBtn);
        buttonsContainer.parentNode.insertBefore(wrapper, buttonsContainer.nextSibling);
      } else {
        productForm.appendChild(buyNowBtn);
      }
    }

    removeGalleryListSemantic() {      
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');      
      if (!galleryList) return;     
      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      

      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');        
      if (FBT) FBT.remove();
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
      
    }  
  });  
}